/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/account'
export default icon
